module.exports = __webpack_public_path__ + "static/media/prokaryotes_gene_lists.40bd529d.png";